import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse, UUID } from '@dopomogai/types';
import type { ToolTemplateResponse, ToolTemplateUpdatePayload } from '@dopomogai/types';

export const toolTemplateService = {
  getAgentToolTemplate: (
    agentId: UUID,
    toolSlug: string
  ): ServiceResponse<ToolTemplateResponse> => {
    return getApiClient()
      .get<ToolTemplateResponse>(`/agents/${agentId}/tools/${encodeURIComponent(toolSlug)}/template`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `getting tool template for ${toolSlug}`));
  },

  setAgentToolTemplate: (
    agentId: UUID,
    toolSlug: string,
    payload: ToolTemplateUpdatePayload
  ): ServiceResponse<ToolTemplateResponse> => {
    return getApiClient()
      .put<ToolTemplateResponse>(`/agents/${agentId}/tools/${encodeURIComponent(toolSlug)}/template`, payload)
      .then(res => res.data)
      .catch(err => handleApiError(err, `updating tool template for ${toolSlug}`));
  },
};